export default __webpack_public_path__ + "static/media/image-curiosity.7f14665a.jpg";